import { VApp } from 'vuetify/lib/components/VApp';
import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VApp,[_c(VContainer,[_c('matchComponent',{staticClass:"mb-10"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }